import React from "react";
import ReadSectionCard from "./Components/ReadSectionCard";
import { isEqual } from "@Util/utils";
import { ORDER_INVOICE_ISSUING_TYPE, INVOICE_CARRIER_TYPE } from "@Constants/";

const InvoiceSectionByRead = props => {
	const { invoice } = props;

	const items = [
		// 基本欄位
		{ label: "發票類型", xs: 4, value: invoice?.issuingTypeText },

		// 愛心碼（捐贈）
		...(isEqual(invoice?.issuingType, ORDER_INVOICE_ISSUING_TYPE.DONATE) ? [{ label: "愛心碼", xs: 4, value: invoice?.donationCode }] : []),

		// 二聯
		...(isEqual(invoice?.issuingType, ORDER_INVOICE_ISSUING_TYPE.DUPLICATEUNIFORMINVOICE)
			? [
					{ label: "發票載具", xs: 4, value: invoice?.carrierTypeText },
					...(isEqual(invoice?.carrierType, INVOICE_CARRIER_TYPE.MOBILEBARCODE) || isEqual(invoice?.carrierType, INVOICE_CARRIER_TYPE.CITIZENDIGITALCERTIFICATE)
						? [{ label: "載具號碼", xs: 4, value: invoice?.carrierNo }]
						: []),
			  ]
			: []),

		// 三聯
		...(isEqual(invoice?.issuingType, ORDER_INVOICE_ISSUING_TYPE.TRIPLICATEUNIFORMINVOICE)
			? [
					{ label: "統一編號", xs: 4, value: invoice?.taxID },
					{ label: "發票抬頭", xs: 4, value: invoice?.taxTitle },
			  ]
			: []),

		// 通知/寄送
		{ label: "寄送載具信箱", xs: 4, value: invoice?.mail },
		{ label: "通知手機號碼", xs: 4, value: invoice?.cellPhone },
	];

	return <ReadSectionCard title="發票資訊" outlined={false} raised={false} headerBg="black" gridSpacing={3} hideEmpty={false} items={items.map(it => ({ placeholder: "無資料", ...it }))} />;
};

export default InvoiceSectionByRead;
